import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PublicRoute = (props: any) => {
  const token = useSelector((state: any) => state.auth.token);
  return token ? <Navigate to="/" /> : <Outlet />;
};

export default PublicRoute;
